import script from "./UnprocessedDocumentsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnprocessedDocumentsPage.vue?vue&type=script&setup=true&lang=ts"

import "./UnprocessedDocumentsPage.vue?vue&type=style&index=0&id=b33af184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b33af184"]])

export default __exports__